import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

import Link from "@mui/material/Link";

const UserAction = props => {
  const { log, clients, handleClientClick } = props;  

  const customer = log?.ClientId
    ? clients.find(client => client.Ssn === log.ClientId)
    : null;

  let customerName = customer
    ? customer.Name
      ? customer.Name
      : (customer.FirstName !== null ? (customer.FirstName + " " + customer.LastName) : "")
    : "";

  let action = "";
  switch (log.Action) {
    case "USER_AUTHENTICATED":
      action = `Loggade in`;
      break;
    case "CASE_CREATED":
      action = `Skapade ärende för kund `;
      break;
    case "CASE_OPEN":
      action = `Öppnade ärende för kund`;
      break;
    case "CASE_COPIED":
      action = `Kopierade ärende för kund`;
      break;
    case "CASE_SIGNED":
      action = `Signerade ärende för kund`;
      break;
    case "NAV_START_PAGE":
      action = `Sida: Start`;
      break;
    case "NAV_ADVISOR_SESSIONS":
      action = `Sida: Rådgivningar`;
      break;
    case "NAV_OTHER_SESSIONS":
      action = `Sida: Övriga ärenden`;
      break;
    case "NAV_FUTUR_SESSIONS":
      action = `Sida: Futur, ansökningar`;
      break;
    case "NAV_FUTUR_WITHDRAWALS":
      action = `Sida: Futur, återköp`;
      break;
    case "NAV_POA_SESSIONS":
      action = `Sida: Fullmakter`;
      break;
    case "NAV_KYC_SESSIONS":
      action = `Sida: KYC`;
      break;
    case "NAV_SIGNED_VOLUME_REPORTS":
      action = `Sida: Rapport, signerad volym`;
      break;
    case "NAV_USERS_VIEW":
      action = `Sida: Systemanvändare`;
      break;
    case "NAV_COMPANIES_VIEW":
      action = `Sida: Företagsinformation`;
      break;
    case "NAV_USER_ACTIVITY_VIEW":
      action = `Sida: Användaraktivitet`;
      break;
    case "CASE_RECALLED":
      action = `Återkallade ärende för kund `;
      break;
    case "CASE_DELETED":
      action = `Raderade ärende för kund `;
      break;
    case "VIEW_CUSTOMER_MODAL":
      action = `Visade kundinformation för kund `;
      break;
    case "DOWNLOAD_SIGNED_PDF":
      action = `Laddade ner signerad PDF`;
      break;
    default:
      action = log.Action;
      break;
  }

  return (
    <span>
      {action}{" "}
      {customer && customerName && (
        <Link
          href="#"
          onClick={handleClientClick(customer.Ssn)}
          color="primary"
          underline="always"
        >
          {customerName}
        </Link>
      )}
      {log.CaseId && (
          <React.Fragment>
            <a href={"https://app.assently.com/a/case/view/" + log.CaseId} target={"_blank"} rel="noreferrer">
              <span style={{display: "block", color: "#95a4ac", lineHeight: "15px", fontWeight: "normal"}}>
                {log.CaseId}
              </span>
            </a>
          </React.Fragment>
      )}
    </span>
  );
};

UserAction.propTypes = {
  log: PropTypes.object.isRequired,
  clients: PropTypes.array.isRequired,
  handleClientClick: PropTypes.func.isRequired
};

export default UserAction;
